'use strict';

/**
 * Script depends on sizeChartOptions custom preference being set properly as
 * it will pull the sub category options from the global SIZE_CHART_OPTIONS
 * variable that is created on the template.
*/

var formValidation = require('base/components/formValidation');

/**
 *
 * @param {element} select - a select element from DOM
 * @param {Object} options - an object containing key value pairs for select option
 */
function appendSelectOptions(select, options) {
    /* eslint-disable guard-for-in, no-restricted-syntax */
    for (var prop in options) {
        select.add(new Option(options[prop], prop));
    }
}

/**
 *
 * @param {element} select - a select element from DOM
 */
function removeSelectOptions(select) {
    for (let option in select.options) {
        select.remove(option);
    }

    select.add(new Option('Select a sub-category', '', true, true));
}

/**
 *
 */
function watchSelectChange() {
    var categorySelect = document.getElementById('categorySelect');
    if (categorySelect) {
        categorySelect.addEventListener('change', function () {
            let subCategorySelect = document.getElementById('subCategorySelect');
            removeSelectOptions(subCategorySelect);
            /* eslint-disable no-undef */
            appendSelectOptions(subCategorySelect, SIZE_CHART_OPTIONS[this.value]);
        });
    }
}

/**
 * getSizeChart - Get size chart using Product-SizeChart controller. Content ID is formed from select options concatenated.
 */
function getSizeChart() {
    $('#sizeChartSelector').on('submit', function (e) {
        e.preventDefault();
        let form = $(this);

        // var url = `${form.action}size-chart-${formData.categorySelect.value}-${formData.subCategorySelect.value}`;
        var $prodSizeChart = $('.size-chart-container');
        $.ajax({
            url: form.attr('action'),
            type: 'get',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                if (!data.success) {
                    form.spinner().stop();
                    formValidation(form, data);
                    $prodSizeChart.empty();
                    let newHeading = document.createElement('h3');
                    newHeading.classList.add('h5');
                    let errorMessage = document.createTextNode('Sorry, we couldn\'t find that size chart.');
                    newHeading.appendChild(errorMessage);
                    $prodSizeChart.append(newHeading);
                } else {
                    $prodSizeChart.empty();
                    $prodSizeChart.append(data.content);
                    form.spinner().stop();
                }
            },
            error: function () {
                form.spinner().stop();
            }
        });
    });
}

/**
 *
 */
function getCurrentSelection() {
    let category = document.getElementById('categorySelect');
    if (category) {
        let categoryValue = category.value;
        let subCategory = document.getElementById('subCategorySelect');
        let subCategoryValue = subCategory.value;
        if (subCategoryValue) {
            getSizeChart();
        } else if (categoryValue) {
            /* eslint-disable no-undef */
            appendSelectOptions(subCategory, SIZE_CHART_OPTIONS[categoryValue]);
        }
    }
}

$(document).ready(function () {
    getCurrentSelection();
    watchSelectChange();
    getSizeChart();
});
